window.onload = function () {

    $('.ais-SearchBox-input').bind('keyup focus', function (e) {

        (() => { window.nostojs = window.nostojs || (cb => { (window.nostojs.q = window.nostojs.q || []).push(cb); }); })();
        nostojs(api => api.setAutoLoad(false));
        setTimeout(function () {
            nostojs(api => api.loadRecommendations());
        }, 3000);
    });

}



